<template>
  <div class="school-home-page">
    <div class="frame">
      <div class="menu">
        <el-menu
          :default-active="activeMenu"
          class="el-menu-demo"
          unique-opened
          background-color="#f6f8f9"
          text-color="#606266"
          active-text-color="#3371ff"
        >
          <el-submenu
            v-for="(item, index) of $store.getters.adminpermisionList"
            :key="index"
            :index="index.toString()"
          >
            <template slot="title">
              <i
                style="margin-left: 40px; font-size: 22px"
                :class="item.icon_url"
              ></i>
              <span style="font-size: 16px">{{ item.name }}</span>
            </template>

            <el-menu-item
              v-for="(item2, index) of item.children"
              :key="index"
              :index="item2.permission_key.toString()"
              @click="$router.push({ name: item2.permission_key })"
              :disabled="item2.permission_key == '/'"
              ><span style="margin-left: 60px">{{
                item2.name
              }}</span></el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
      <section>
        <container></container>
      </section>
    </div>
  </div>
</template>

<script>
import container from "./container";
import { adminFreshAuthUserData } from "@/api/admin";

export default {
  name: "frame",
  components: {
    container,
  },
  data() {
    return {
      adminpermisionList: [],
    };
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, name } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return name;
    },
  },
  mounted() {
    console.log("员工权限列表");
    console.log(this.$store.state.user.adminpermisionList);
    this.adminFreshAuthUserData();
  },
  methods: {
    adminFreshAuthUserData() {
      adminFreshAuthUserData().then((res) => {
        console.log("刷新数据");
        console.log(res);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.school-home-page {
  height: calc(100% - 60px);
  background-color: #98a3b84a;
  .frame {
    display: flex;
    width: 100%;
    height: 100%;
    .menu {
      overflow-y: scroll;
      header {
        height: 30px;
      }
      .header-title {
        padding: 5px 0;
        background: #4084ff;
        color: #ffffff;
        font-size: 20px;
        text-align: center;
      }
      .el-menu-demo:not(.el-menu--collapse) {
        width: 220px;
      }
      .el-menu-demo {
        min-height: 100%;
      }
      .el-submenu {
        min-width: 220px;
      }
      .el-menu-item {
        min-width: 220px;
      }
    }
    section {
      flex: 1;
      overflow-y: scroll;
    }
  }
}
</style>
